import React from 'react'
import Skeleton from 'react-loading-skeleton'
import CustomSlider from 'components/Slider'
import useDeviceDetect from 'components/DeviceDetect'

const BrandItemSkeleton = () => (
  <div className="h-[85px] bg-[#F8FAFC] rounded-xl border border-[#F8FAFC] p-4 sm:p-5 flex items-center justify-center mt-10">
    <Skeleton height={40} width={80} />
  </div>
)

const BrandSkeleton = () => {
  const { isTablet } = useDeviceDetect()
  const skeletonCount = 8

  return (
    <>
      <div className="md:hidden brands-slider">
        <CustomSlider
          settings={{
            dots: false,
            swipeToSlide: true,
            slidesToShow: isTablet ? 6 : 4,
            autoplay: false,
          }}
        >
          {Array(skeletonCount)
            .fill()
            .map((_, index) => (
              <BrandItemSkeleton key={index} />
            ))}
        </CustomSlider>
      </div>

      <div className="hidden md:grid grid-cols-8 gap-4">
        {Array(skeletonCount)
          .fill()
          .map((_, index) => (
            <BrandItemSkeleton key={index} />
          ))}
      </div>
    </>
  )
}

export default BrandSkeleton
